import { jsx as _jsx } from "react/jsx-runtime";
// Three horizontal dots, the trigger of an actions menu.
const DotsIcon = ({ ...props }) => (_jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...props, children: [3.5, 8, 12.5].map((x) => (_jsx("circle", { cx: x, cy: "8", r: "1.25" }, x))) }));
export default DotsIcon;
